webpackJsonp([396],{

/***/ 1251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2205:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1251),
  /* template */
  __webpack_require__(3016),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/v2.1.1-rc.11_en-317.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.1.1-rc.11_en-317.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cd3a2e6c", Component.options)
  } else {
    hotAPI.reload("data-v-cd3a2e6c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 3016:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Better transition for mask")])]), _vm._v(" "), _c('h2', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Reset props data when used as plugin")])]), _vm._v(" "), _c('h2', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix plugin value and event watchers")]), _vm._v(" "), _c('li', [_vm._v("[fix] Reset prop data when used as plugin")])]), _vm._v(" "), _c('h2', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support prop:display-format #1086 @greedying")])]), _vm._v(" "), _c('h2', [_vm._v("Loading")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Reset prop data when used as plugin")]), _vm._v(" "), _c('li', [_vm._v("[enhance] Add fade transition")])]), _vm._v(" "), _c('h2', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Fix mask render slowly in Safari. #1083 @sixiakun")]), _vm._v(" "), _c('li', [_vm._v("[enhance] Enable transfer-dom by default")])]), _vm._v(" "), _c('h2', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix wrong overflowScrolling when mask is disabled")])]), _vm._v(" "), _c('h2', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Better mask transition and dialog transition")]), _vm._v(" "), _c('li', [_vm._v("[enhance] Add transfer-dom demo")]), _vm._v(" "), _c('li', [_vm._v("[enhance] Clean unused code")])]), _vm._v(" "), _c('h2', [_vm._v("XTextarea")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add on-focus on-blur event #1082 @zeusLeeJh")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cd3a2e6c", module.exports)
  }
}

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2205);

/***/ })

});


// WEBPACK FOOTER //
// 396.1cc7f993.js